import { Tab, TabList, Tabs } from "@similarweb/ui-components";
import { Box, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { TRAFFIC_SOURCES } from "./constants";
import { useTrafficSourceTabsContext } from "./TrafficSourceTabsContext";

export const TrafficSourceTabs = () => {
    const translate = useTranslation();
    const [selectedIndex, setSelectedIndex] = useTrafficSourceTabsContext();

    return (
        <Box width="100%">
            <Tabs
                selectedIndex={selectedIndex}
                onSelect={setSelectedIndex}
            >
                <TabList>
                    {TRAFFIC_SOURCES.map((source) => (
                        <Tab
                            key={`${source.value}-tab`}
                            data-automation={`${source.value}-tab`}
                        >
                            <Text fontVariant="tab">{translate(source.title)}</Text>
                        </Tab>
                    ))}
                </TabList>
            </Tabs>
        </Box>
    );
};
